import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const SelectRole = () => {

    const location = useLocation();

    return (
        <>
            <div className="select-role-box">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-md-12">
                            <h1 className='home-main-heading'>Select Role:</h1>
                        </div> */}

                        <div className="col-md-12">
                            <div className="role-box-main">
                                <Link to="/user/signup">
                                    <div className={`role-box ${location.pathname === '/user/signup' ? 'active-role-class' : ''}`}>
                                        <span className="role-box-icon">
                                            <img src="/images/role-icon1.svg" alt="User Icon" />
                                        </span>
                                        <h2>User</h2>
                                    </div>
                                </Link>

                                <Link to="/corporate/signup">
                                    <div className={`role-box ${location.pathname === '/corporate/signup' ? 'active-role-class' : ''}`}>
                                        <span className="role-box-icon">
                                            <img src="/images/role-icon2.svg" alt="Corporate Icon" />
                                        </span>
                                        <h2>Corporate</h2>
                                    </div>
                                </Link>

                                <Link to="/professional/signup">
                                    <div className={`role-box ${location.pathname === '/professional/signup' ? 'active-role-class' : ''}`}>
                                        <span className="role-box-icon">
                                            <img src="/images/role-icon3.svg" alt="Professionals Icon" />
                                        </span>
                                        <h2>Professionals</h2>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectRole